import { render, staticRenderFns } from "./SportsListItem.vue?vue&type=template&id=3763cff4&scoped=true"
import script from "./SportsListItem.vue?vue&type=script&lang=js"
export * from "./SportsListItem.vue?vue&type=script&lang=js"
import style0 from "./SportsListItem.vue?vue&type=style&index=0&id=3763cff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763cff4",
  null
  
)

export default component.exports